// extracted by mini-css-extract-plugin
export var backgroundImage = "contact-module--backgroundImage--3673a";
export var bottomBox = "contact-module--bottomBox--73b46";
export var contactSection = "contact-module--contactSection--03bb3";
export var container = "contact-module--container--b0465";
export var innerWrapper = "contact-module--innerWrapper--31167";
export var left = "contact-module--left--6e89c";
export var outerWrapper = "contact-module--outerWrapper--8163f";
export var right = "contact-module--right--c42b2";
export var twoColumnFlexContainer = "contact-module--twoColumnFlexContainer--db5a2";